/* eslint-disable react/prop-types */
// import React from "react";

export const CheckActionPermission = ({component , permission}) => {
    if(permission){
        return component;
    }
    else return null;
};